import { Alert, AlertProps } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import styles from './base.module.css';

export const BaseAlert = (props: AlertProps) => {
	return (
		<Alert icon={<IconInfoCircle />} variant="filled" bg="green.2" classNames={styles} {...props} />
	);
};
